import { PropsWithChildren } from "react";

import MainWrapper from "./main.styles";

const Main = ({ children }: PropsWithChildren) => {
  return <MainWrapper>{children}</MainWrapper>;
};

export default Main;
